export function showChatGlobalLoader(target = null, options = {}) {
  if (!window.growtypeLoader?.show) {
    return jQuery();
  }

  const chatTarget = target || ".g-chatform";
  const loader = window.growtypeLoader.show(chatTarget, options);
  const $chatForm = target?.jquery ? target.first() : jQuery(chatTarget).first();

  $chatForm.addClass("is-busy");

  return loader ? jQuery(loader) : jQuery();
}

export function hideChatGlobalLoader(target = null) {
  if (!window.growtypeLoader?.hide) {
    return;
  }

  const chatTarget = target || ".g-chatform";
  const $chatForm = target?.jquery ? target.first() : jQuery(chatTarget).first();

  $chatForm.removeClass("is-busy");
  window.growtypeLoader.hide(chatTarget);
}

export function initChatGlobalLoader() {
  window.growtypeChatGlobalLoader = {
    show: showChatGlobalLoader,
    hide: hideChatGlobalLoader,
  };

  window.growtypeChatShowLoader = showChatGlobalLoader;
  window.growtypeChatHideLoader = hideChatGlobalLoader;
}
